// extracted by mini-css-extract-plugin
module.exports = {"container":"closeButton_container__2tzcQ","text":"closeButton_text__2d3WN"};